export default "__VITE_ASSET__CZC6j1E___"